export enum FamilyUserStatusIDEnum {
  Requested = 0,
  Accepted = 1,
  Denied = 2,
  Removed = 3,
  RequestCancelled = 4,
}
